// Vad kunden får se direkt när förfrågan är skickad (ADR 0047). Svaret beror
// på beslutet och byråns utskicksläge, enligt avsnittet "Widgeten" i
// docs/ARCHITECTURE.md.
import { z } from 'zod';
import { quoteViewSchema } from './quote-view.js';

export const inquiryResultSchema = z.discriminatedUnion('type', [
  /** Offerten skickades direkt. Widgeten visar den, och den kommer också med e-post. */
  z.object({ type: z.literal('quote'), quoteToken: z.string(), quote: quoteViewSchema }),
  /** Offerten kommer med e-post vid sändtiden. */
  z.object({ type: z.literal('scheduled'), sendAt: z.iso.datetime() }),
  /** Byrån går igenom offerten och återkommer inom kort. */
  z.object({ type: z.literal('review') }),
  /** Byrån svarar personligen, till exempel på en fråga. */
  z.object({ type: z.literal('message') }),
]);

export type InquiryResult = z.infer<typeof inquiryResultSchema>;
